import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { device, useRevealTrail } from '@landsbankinn/ui';
import React from 'react';
import res from './Shortcuts.res';

const Host = styled.nav`
  display: flex;
  justify-content: space-around;
  flex-flow: row wrap;

  margin: 0 -10px;
  @media ${device.mobile} {
  }

  > a {
    flex: 1;
    width: 50%;

    @media ${device.mobile} {
      width: 33%;
      flex: 33%;
    }

    @media ${device.tablet} {
      width: ${100 / 6}%;
      flex: ${100 / 6}%;
    }

    @media ${device.desktop} {
      flex: 1;
      width: auto;
    }
  }
`;

interface IProps {
  children: React.ReactNode;
}

export const Shortcuts = ({ children, ...rest }: IProps) => {
  const { r } = useResource();
  const { ref, itemsWithStyleProp } = useRevealTrail(children);
  return (
    <Host ref={ref} {...rest} aria-label={r(res.shortcuts)}>
      {itemsWithStyleProp}
    </Host>
  );
};
